import { AxiosResponse } from "axios"
import { coreAxios } from "./axios"

export function getAuths(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/auths`, {
        params: params
    })
}

/**
 * 获得用户在项目中的文件权限
 * @param projectId 
 * @param userId 
 * @param params 
 * @returns 
 */
export function getFileAuths(projectId: number, userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/file-auths`, {
        params: {
            ...params,
            userId: userId
        }
    })
}

export function getRsUserAuths(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/auths/rs-user`, {
        params: {
            ...params,
            userId: userId
        }
    })
}

/**
 * 获得用户的文件权限
 * @param userId 
 * @param params 
 * @returns 
 */
export function getRsUserFileAuths(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/file-auths/rs-user`, {
        params: {
            ...params,
            userId: userId
        }
    })
}


export function updateAuths(authIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/auths`, authIds, {
        params: params
    })
}

/**
 * 更新用户文件夹权限
 * @param authIds 
 * @param params 
 * @returns 
 */
export function updateUserFileAuths(authIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/file-auths`, authIds, {
        params: params
    })
}
